<template>
  <v-container fluid>
    <template>
      <v-container fluid>
        <v-expansion-panels flat style="border: 1px solid #0482fb">
          <v-expansion-panel class="elevation-0 pa-0">
            <v-expansion-panel-header>
              <span>
                <v-icon class="ml-2" left> mdi-filter-variant </v-icon> Tri /
                Recherche ...
              </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-col cols="12" md="12">
                <v-text-field outlined color="#0482fb" label="Recherche par mot clé" class="pt-5 pa-2"
                  prepend-inner-icon="mdi-magnify" dense v-model="searchData" @change="showAllFillData" flat
                  background-color="grey lighten-4"></v-text-field>
              </v-col>
              <!-- <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn 
                color="#0482fb"
                
                pill
                
                class="mr-2"
                @click="saveProspect"
              >
                            <v-icon left>
                mdi-magnify
              </v-icon>
                Appliquer la recherche
              </v-btn>
            </v-card-actions> -->
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-container>
      <v-toolbar flat>
        <h4 class="text-h4 pageTitle ">
          Prospect / Client
        </h4>
        <v-divider class="mx-4" inset vertical></v-divider>

        <v-switch v-model="showAllFil" label="Afficher toutes les données" color="#0482fb" @change="showAllFillData"
          class="pt-5"></v-switch>
        <v-spacer></v-spacer>
      </v-toolbar>
    </template>
    <v-data-table class="pt-3" flat :loading="loading ? '#0482fb' : null" :headers="headers" :search="searchData"
      :items="Files.docs" :items-per-page="10" sort-by="">
      <template v-slot:top>
        <v-toolbar class="ml-0 pl-0" flat>
          <v-btn class="mr-2 btnDesign" dark color="#0482fb" text-color="white" @click="addProspect" v-bind="attrs" pill
            v-on="on">
            <v-icon left>
              mdi-account-outline
            </v-icon>
            Ajout Prospect
          </v-btn>

          <v-spacer></v-spacer>
        </v-toolbar>
      </template>
      <!-- <template v-slot:item.actions="{ item }">
        <v-icon color="warning" @click="updateProspect(item)">
          mdi-pencil-box-multiple-outline</v-icon
        >

        <v-btn  class="ml-10" icon :to="`/prospection/${item._id}`">
          <v-icon :to="`/prospection/${item._id}`" size="30" color="success"
            >mdi-arrow-right-circle-outline</v-icon
          >
        </v-btn>
      </template> -->
      <template v-slot:item="{ item }">
        <tr @click="handleClick(item)" class="green-bg">
          <!-- <td>
                <v-chip :color="getColor(item.status)" dark>
                  {{ item.status }}
                </v-chip>
              </td> -->
          <td>
            {{ item.actions }}
            <v-menu elevation="0" right offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on" class="mr-10">
                  <v-icon color="success" size="30">mdi-forwardburger</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-tooltip bottom color="warning">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn class="ml-3" icon>
                      <v-icon size="20" @click="updateProspect(item)" v-bind="attrs" v-on="on"
                        color="warning">mdi-pencil-box-multiple-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Modification des informations du prospect</span>
                </v-tooltip>
                <v-tooltip bottom color="success">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn class="ml-3" icon>
                      <v-icon size="20" color="success" v-bind="attrs" v-on="on"
                        @click="appelsModalFunction(item)">mdi-phone</v-icon>
                    </v-btn>
                  </template>
                  <span>Gestion des appel</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn class="ml-3" icon>
                      <v-icon size="20" v-bind="attrs" v-on="on"
                        @click="appointmentDialogFunction(item)">mdi-calendar-edit</v-icon>
                    </v-btn>
                  </template>
                  <span>Gestion des rendez-vous</span>
                </v-tooltip>

                <v-tooltip bottom color="primary">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn class="ml-3" icon>
                      <v-icon @click="productDialogFunction(item)" v-bind="attrs" v-on="on" size="20"
                        color="primary">mdi-package-variant-closed</v-icon>
                    </v-btn>
                  </template>
                  <span>Gestion de produit</span>
                </v-tooltip>

                <v-tooltip bottom color="purple">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn class="ml-3" icon>
                      <v-icon @click="CotationDialogFunction(item)" v-bind="attrs" v-on="on" size="20"
                        color="purple">mdi-handshake</v-icon>
                    </v-btn>
                  </template>
                  <span>Adresser une demande de cotation à la direction
                    technique</span>
                </v-tooltip>
              </v-list>
            </v-menu>
          </td>
          <td>{{ item.customerNumber }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.nature }}</td>
          <td>{{ item.activityField }}</td>
          <td>{{ item.email }}</td>
          <td>{{ item.phone }}</td>
          <td>{{ item.birthdayFr }}</td>
          <td>{{ item.location }}</td>
          <td>{{ item.city }}</td>
          <td>{{ item.country }}</td>
          <td>{{ item.code }}</td>
        </tr>
      </template>
    </v-data-table>

    <!-- Dialog dalerte a personalier -->
    <v-col cols="auto">
      <v-dialog transition="dialog-bottom-transition" max-width="600" v-model="alert">
        <template>
          <v-card class="mx-auto">
            <v-toolbar color="white" dark>
              <p class="text-h6 pt-5 text--primary">
                Vérification
                <v-icon large color="error darken-2">
                  mdi-alert-circle-check
                </v-icon>
              </p>
            </v-toolbar>
            <v-card-text>
              <div class="text--primary pt-8">
                Votre prospect a été ajouté avec succès. Veuillez procéder à
                l'analyse des produits.
              </div>
            </v-card-text>
            <!-- <v-card-actions class="justify-start">
      <v-btn 
      text
        color="error accent-4 float-left"
        @click="reveal = true"
      >
       Annuler
      </v-btn>
        </v-card-actions> -->
            <v-card-actions class="justify-end">
              <!-- <v-btn 
          text
        color="warning accent-4 float-right"
        @click="reveal = true"
      >
       plus d'informations
      </v-btn> -->
              <!-- <v-btn 
            text
        color="success accent-4 float-right"
        @click="reveal = true"
      >
      Confirmer
      </v-btn> -->
            </v-card-actions>

            <v-expand-transition>
              <v-card v-if="reveal" class="transition-fast-in-fast-out v-card--reveal purple darken-2"
                style="height: 100%">
                <v-card-text class="pb-0">
                  <p class="text-h5">Détaille sur action</p>
                  <p class="text--success">late</p>
                </v-card-text>
                <v-card-actions class="pt-0">
                  <v-btn text color="white accent-4 float-right" @click="reveal = false">
                    Réduire
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-expand-transition>
          </v-card>
        </template>
      </v-dialog>
    </v-col>

    <!--  Pop up add file-->
    <v-dialog v-model="fileDialog" max-width="1000px">
      <v-card style="border-top: 10px solid #0482fb">
        <v-card-title>
          <span class="text-h5">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="4">
                <v-select outlined v-model="fileModal.nature" :items="natureprospect" label="Nature Prospect"
                  background-color="#4DD0E1"></v-select>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field outlined color="#0482fb" background-color="#4DD0E1" v-model="fileModal.name"
                  label="Nom / Raison Sociale"></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field outlined color="#0482fb" v-model="fileModal.oldCustomerNumber"
                  label="Ancien code"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field outlined color="#0482fb" v-model="fileModal.phone" label="Téléphone"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field outlined color="#0482fb" background-color="#4DD0E1" v-model="fileModal.email"
                  :rules="emailRules" label="Mail"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field outlined color="#0482fb" v-model="fileModal.activityField"
                  label="Domaine d'activité"></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field outlined color="#0482fb" v-model="fileModal.location" label="Adresse"></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field outlined color="#0482fb" v-model="fileModal.city" label="Ville"></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field outlined color="#0482fb" v-model="fileModal.country" label="Pays"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3" tile>
                <v-text-field outlined color="#0482fb" v-model="fileModal.birthday" type="date" :label="
                  fileModal.nature === 'Physique'
                    ? 'Date d\'anniversaire'
                    : 'Date de création'
                "></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field outlined color="#0482fb" v-model="fileModal.NIF" label="N.I.F"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-select outlined v-model="fileModal.STAT" :items="listeReseau" label="Réseau"
                  background-color="#4DD0E1"></v-select>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field outlined color="#0482fb" v-model="fileModal.RCA" label="RCCM"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-container class="grey lighten-5">
                  <v-data-table style="text-align:right;" :headers="correspondant" :items="corresspondantData">
                    <template v-slot:item.actions="{ item }">
                      <v-row>
                        <v-icon color="warning" @click="editCorrespondant(item)">
                          mdi-pencil-box-multiple-outline</v-icon>

                        <v-icon @click="deletCorrespondant(item)" class="ml-5" color="error">mdi-delete-empty</v-icon>
                      </v-row>
                    </template>

                    <template v-slot:top>
                      <v-toolbar flat>
                        <v-toolbar-title>Correspondants</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                        <v-dialog v-model="correspondantModal" max-width="500px">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn color="#0482fb" dark class="mb-2" v-bind="attrs" v-on="on">
                              <v-icon left>
                                mdi-account-outline
                              </v-icon>
                              Ajouter un correspondant
                            </v-btn>
                          </template>
                          <v-card style="border-top: 10px solid #0482fb" max-width="500px">
                            <v-card-title>
                              <span class="text-h5">{{
                                correspondantTitle
                              }}</span>
                            </v-card-title>

                            <v-card-text>
                              <v-container>
                                <v-row>
                                  <v-col cols="12" md="6">
                                    <v-text-field outlined color="#0482fb" v-model="correspondantItem.fullName"
                                      label="Nom et Prénoms"></v-text-field>
                                  </v-col>
                                  <v-col cols="12" sm="6" md="6">
                                    <v-text-field outlined color="#0482fb" v-model="correspondantItem.affluenceType"
                                      label="Titre"></v-text-field>
                                  </v-col>
                                  <v-col cols="12" md="6">
                                    <v-text-field outlined color="#0482fb" v-model="correspondantItem.contact"
                                      label="Contact"></v-text-field>
                                  </v-col>
                                  <v-col cols="12" md="6">
                                    <v-text-field outlined color="#0482fb" v-model="correspondantItem.email"
                                      label="Mail"></v-text-field>
                                  </v-col>
                                  <v-col cols="12" md="6">
                                    <v-text-field outlined color="#0482fb" v-model="correspondantItem.birthday"
                                      type="date" label="Date d'anniversaire"></v-text-field>
                                  </v-col>
                                </v-row>
                              </v-container>
                            </v-card-text>

                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn color="error" text @click="correspondantClose">
                                Fermer
                              </v-btn>
                              <v-btn depressed large :loading="loading ? '#0482fb' : null" @click="addPersonnel"
                                color="success">
                                Ajouter
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                        <v-dialog v-model="correspondantModalDelete" max-width="500px">
                          <v-card>
                            <v-card-title class="text-h5">Etes vous sûr de vouloir supprimer cet élément
                              ?</v-card-title>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                              <v-btn color="blue darken-1" text @click="correspondantConfirm">OK</v-btn>
                              <v-spacer></v-spacer>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </v-toolbar>
                    </template>
                  </v-data-table>
                </v-container>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error darken-1" text @click="fileDialog = false">
            Fermer
          </v-btn>
          <v-btn color="success darken-1" :loading="loading ? '#0482fb' : null" @click="saveProspect">
            Enregistrer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="AlertProspect" max-width="800px">
      <v-sheet style="border-top: 10px solid #0482fb" class="px-7 pt-7 pb-4  text-center d-inline-block">
        <div class="black--text text--lighten-1 text-body-2 mb-4">
          Voulez-vous programmer un appel, un rendez-vous ou effectuer la
          proposition de produit sur ce prospect ?
        </div>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" class="mr-3 pa-2" small @click="appelsModalFunction(dataGet.data)">
            <v-icon size="20" class="ma-2">mdi-phone</v-icon>
            Programmer un appel</v-btn>
          <v-btn small class="mr-3" @click="appointmentDialogFunction(dataGet.data)"><v-icon size="20"
              class="ma-2">mdi-calendar-edit</v-icon>Programmer
            un rendez-vous</v-btn>
          <v-btn color="primary" small class="mr-3" @click="productDialogFunction(dataGet.data)"><v-icon size="20"
              class="ma-2">mdi-package-variant-closed</v-icon>Gestion de produits</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-sheet>
    </v-dialog>

    <!--  Pop up des call-->
    <template>
      <v-dialog v-model="appelsModal" overlay max-width="1000px" transition="dialog-bottom-transition" scrollable>
        <callModalComponent :callRequest="Object.assign({}, this.fileObject)" />
      </v-dialog>
    </template>
    <!--  Pop up des rdv-->
    <template>
      <v-dialog v-model="rdvModal" overlay max-width="1000px" transition="dialog-bottom-transition" scrollable>
        <rdvModalComponent v-if="rdvModal" :rdvRequest="Object.assign({}, this.fileObject)" />
      </v-dialog>
    </template>
    <!--  Pop up des produit-->
    <template>
      <v-dialog v-model="productModal" overlay max-width="1000px" transition="dialog-bottom-transition" scrollable>
        <productodalComponent v-if="productModal" :rdvRequest="Object.assign({}, this.fileObject)" />
      </v-dialog>
    </template>
    <!--  Pop up des Cotation-->
    <template>
      <v-dialog v-model="quotingModal" overlay max-width="1000px" transition="dialog-bottom-transition" scrollable>
        <cotationModalComponent @closeDialog="closeQuoting" v-if="quotingModal"
          :rdvRequest="Object.assign({}, this.fileObject)" />
      </v-dialog>
    </template>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { defaultMethods, messages } from "../utils/data";
import { addFile, updateFile } from "../api/admin";
import callModalComponent from "../components/modal/callModal.vue";
import rdvModalComponent from "../components/modal/rdvModal.vue";
import productodalComponent from "../components/modal/productModal.vue";
import cotationModalComponent from "../components/modal/cotingProspect.vue";
export default {
  name: "production",
  components: {
    callModalComponent,
    rdvModalComponent,
    productodalComponent,
    cotationModalComponent,
  },
  data: () => ({
    panel: [],
    switch1: true,
    tab: null,
    perssonel: [],
    quotingModal: false,
    appelsModal: false,
    productModal: false,
    rdvModal: false,
    dataGet: {},
    garantietitre: [
      {
        tab: "RESPONSABILITE CIVILE CHEF D'ENTREPRISE",
        content: "Tab 1 Content",
      },
      { tab: "MULTIRISQUE PROFESSIONNELLE", content: "Tab 2 Content" },
      { tab: "GLOBAL DE BANQUE BOA", content: "Tab 3 Content" },
      { tab: "MULTIRISQUE HABITATION", content: "Tab 4 Content" },
      { tab: "TRC", content: "Tab 5 Content" },
      { tab: "IND", content: "Tab 6 Content" },
    ],
    items: ["Physique", "Morale"],
    natureprospect: ["Entreprise Privée", "Entreprise Publique", "Monsieur", "Madame", "ONG", "Prestataire"],
    listeReseau: ["DAYO BENIN", "WTW", "JA DELMAS", "AUTRES FILIALES","AUTRES COURTIERS","COMMERCIAUX"],
    focus: "",
    events: [],
    type: "month",
    typeToLabel: {
      month: "Month",
      week: "Week",
      day: "Day",
      "4day": "4 Days",
    },
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    fileObject: [],
    searchData: "",
    colors: ["red"],
    names: ["Appel"],
    colorss: ["green"],
    namess: ["Rendez vous"],
    categories: ["John Smith"],
    addgarantie: false,
    dialog: false,
    appels: false,
    newappel: false,
    rdv: false,
    reveal: false,
    startDate: "",
    endDate: "",
    produit: false,
    showAllFil: false,
    alert: false,
    cotation: false,
    garantie: false,
    contrat: false,
    notifications: false,
    sound: true,
    widgets: false,
    loading: false,
    correspondantModal: false,
    correspondantModalDelete: false,
    correspondant: [
      { text: "Actions", align: "left", value: "actions" },
      { text: "Type d'influence", value: "affluenceType" },
      {
        text: "Nom et Prénoms ",
        align: "start",
        sortable: false,
        value: "fullName",
      },

      { text: "Contacts", value: "contact" },
      { text: "Mail", value: "email" },
      { text: "Date d'anniversaire", value: "birthday" },
    ],
    corresspondantData: [],
    correspondantIndex: -1,
    correspondantItem: {
      fullName: "",
      contact: "",
      email: "A@A",
      birthday: "",
      affluenceType: "",
    },
    corresspondantdefaultItem: {
      fullName: "",
      contact: "",
      email: "",
      birthday: "",
      affluenceType: "",
    },
    affluanceTypes: ["Physique", "Morale"],
    prospect: false,
    AlertProspect: false,
    categoriegarantie: [
      {
        titreCatégorie: "I- Responsabilité Civile Exploitation",
        value1: "",
        value2: "",
        Souscategoriegarantie: [
          {
            titreCatégorie: "domage",
            value1: "",
            value2: "",
          },
          {
            titreCatégorie: "domage",
            value1: "",
            value2: "",
          },
        ],
      },
      {
        titreCatégorie: "II- Responsabilité Civile Professionnelle",
        value1: "",
        value2: "",
        Souscategoriegarantie: [
          {
            titreCatégorie: "Domage1",
            value1: "",
            value2: "",
          },
        ],
      },
      {
        titreCatégorie: "III- Défense et Recours",
        value1: "10 000 000",
        value2: "Néant",
      },
    ],
    produitsugest: [
      {
        text: " Liste des produits",
        value: "name",
      },
    ],
    produittake: [
      {
        text: "Liste des produits Proposer",
        value: "nom",
      },
    ],
    headers: [
      {
        text: "Actions",
        width: "150px",
        align: "left",
        value: "actions",
        sortable: false,
      },
      {
        text: "Numéro client",
        align: "start",
        sortable: false,
        value: "customerNumber",
        width: "200px",
      },
      {
        text: "Nom / Raison Sociale",
        align: "start",
        sortable: false,
        value: "name",
        width: "200px",
      },
      { text: "Nature", width: "200px", value: "nature" },
      // { text: "Description", value: "description" },
      { text: "Domaine d'activité", width: "200px", value: "activityField" },
      { text: "Mail", width: "200px", value: "email" },
      { text: "Téléphone", width: "200px", value: "phone" },
      {
        text: "Date d'anniversaire / Date création",
        width: "250px",
        value: "birthdayFr",
      },
      { text: "Localité", width: "200px", value: "location" },
      { text: "Ville", width: "200px", value: "city" },
      { text: "Pays", width: "200px", value: "country" },
      { text: "Application code", width: "200px", value: "code" },
    ],
    listproduit: [
      {
        name: "Cart d'identité",
      },
      {
        name: "permis de conduit",
      },
      {
        name: "Atestation de residence",
      },
    ],
    prospectdata: [],
    editedIndex: -1,
    fileModal: {
      name: "",
      nature: "",
      phone: "",
      activity: "",
      email: "",
      birthday: "",
      location: "",
      city: "",
      country: "",
      prospects: [],
    },
    defaultItem: {
      name: "",
      nature: "",
      phone: "",
      activity: "",
      email: "",
      birthday: "",
      location: "",
      city: "",
      country: "",
      prospects: [],
    },
    email: "",
    name: "",
    contact: "",
    birthday: "",
    emailRules: [
      (v) => !!v || "E-mail is ",
      (v) => /.+@.+/.test(v) || "E-mail must be valid",
    ],
    fileDialog: false,
  }),

  mounted() {
    this.initFiles();
    this.$refs.calendar.checkChange();
  },
  computed: {
    ...mapGetters(["Files", "File"]),
    formTitle() {
      return this.editedIndex === -1
        ? "Enregistrement d'un nouveau Prospect"
        : "Modification des informations du Prospect ";
    },
    correspondantTitle() {
      return this.correspondantIndex === -1
        ? "Ajouter un correspondant"
        : "Modifier informations correspondant";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    correspondantModal(val) {
      val || this.correspondantClose();
    },
    correspondantModalDelete(val) {
      val || this.correspondantDelete();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    ...mapActions(["getFiles", "getFile"]),
    initialize() {
      this.prospectdata = [];
    },
    closeForm() {
      this.fileModal = {
        birthday: "",
        prospects: [],
      };
      this.fileDialog = false;

      this.editedIndex = -1;
    },
    // files
    showAllFillData() {
      this.initFiles();
      //alert(this.showAllFil);
    },
    async initFiles() {
      this.loading = true;
      try {
        await this.getFiles({
          withoutPeriod: this.showAllFil,
          periodStartDate: this.startDate,
          periodEndDate: this.endDate,
          fileName: this.searchData,
        });
      } catch (error) {
        defaultMethods.dispatchError(
          this.$store,
          messages.failedToLoad("les dossiers")
        );
      }
      this.loading = false;
    },
    async saveProspect() {
      this.loading = true;
      this.fileModal.prospects = this.corresspondantData;
      try {
        if (this.fileModal._id) {
          // update
          await updateFile({
            schema: {
              name: this.fileModal.name,
              prospects: this.fileModal.prospects,
              phone: this.fileModal.phone,
              oldCustomerNumber: this.fileModal.oldCustomerNumber,
              customerNumber: this.fileModal.customerNumber,
              email: this.fileModal.email,
              NIF: this.fileModal.NIF,
              STAT: this.fileModal.STAT,
              RCA: this.fileModal.RCA,
              nature: this.fileModal.nature,
              location: this.fileModal.location,
              description: this.fileModal.description,
              activityField: this.fileModal.activityField,
              birthday: this.fileModal.birthday,
              city: this.fileModal.city,
              country: this.fileModal.country,
              // proposedProducts: this.fileModal.proposedProducts,
            },
            id: this.fileModal._id,
          });

          defaultMethods.dispatchSuccess(
            this.$store,
            messages.updatedSuccessfully("Dossier")
          );

          this.closeForm();
          this.initFiles();
        } else {
          // add
          this.dataGet = await addFile(this.fileModal);
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.createdSuccessfully("Dossier")
          );
          //this.alert = true;
          this.seedNewEvent();
        }
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
        console.log(error);
      }
      this.loading = false;
    },
    seedNewEvent() {
      //alert(JSON.stringify(this.dataGet));
      this.AlertProspect = true;
      this.closeForm();
      this.initFiles();
    },
    all() {
      this.panel = [...Array(this.items.length).keys()].map((k, i) => i);
    },

    initPersonnelForm() {
      this.name = "";
      this.email = "";
      this.contact = "";
      this.birthday = "";
      this.affluenceType = "";
    },
    // Reset the panel
    none() {
      this.panel = [];
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        requestAnimationFrame(() =>
          requestAnimationFrame(() => (this.selectedOpen = true))
        );
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        requestAnimationFrame(() => requestAnimationFrame(() => open()));
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    updateRange({ start, end }) {
      const events = [];

      const min = new Date(`${start.date}T00:00:00`);
      const max = new Date(`${end.date}T23:59:59`);
      const days = (max.getTime() - min.getTime()) / 86400000;
      const eventCount = this.rnd(days, days + 20);

      for (let i = 0; i < eventCount; i++) {
        const allDay = this.rnd(0, 3) === 0;
        const firstTimestamp = this.rnd(min.getTime(), max.getTime());
        const first = new Date(firstTimestamp - (firstTimestamp % 900000));
        const secondTimestamp = this.rnd(2, allDay ? 288 : 8) * 900000;
        const second = new Date(first.getTime() + secondTimestamp);

        events.push({
          name: this.names[this.rnd(0, this.names.length - 1)],
          start: first,
          end: second,
          color: this.colors[this.rnd(0, this.colors.length - 1)],
          timed: !allDay,
        });
      }

      this.events = events;
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },
    addProspect() {
      this.editedIndex = -1;
      (this.corresspondantData = []),
        (this.fileModal = {
          birthday: "",
          prospects: [],
        });
      this.fileDialog = true;
    },
    updateProspect(item) {
      this.editedIndex = 1;
      this.fileModal = Object.assign({}, item);
      this.corresspondantData = this.fileModal.prospects;
      this.fileDialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.prospectdata.indexOf(item);
      this.fileModal = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.prospectdata.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.fileModal = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    closeQuoting() {
      this.quotingModal = false;
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.fileModal = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.prospectdata[this.editedIndex], this.fileModal);
      } else {
        this.prospectdata.push(this.fileModal);
      }
      this.close();
    },

    //Corresspondant
    editCorrespondant(item) {
      this.correspondantIndex = this.corresspondantData.indexOf(item);
      this.correspondantItem = Object.assign({}, item);
      this.correspondantModal = true;
    },

    deletCorrespondant(item) {
      this.correspondantIndex = this.corresspondantData.indexOf(item);
      this.correspondantItem = Object.assign({}, item);
      this.correspondantModalDelete = true;
    },

    correspondantConfirm() {
      this.corresspondantData.splice(this.correspondantIndex, 1);
      this.correspondantDelete();
    },

    correspondantClose() {
      this.correspondantModal = false;
      this.$nextTick(() => {
        this.correspondantItem = Object.assign(
          {},
          this.corresspondantdefaultItem
        );
        this.correspondantIndex = -1;
      });
    },

    correspondantDelete() {
      this.correspondantModalDelete = false;
      this.$nextTick(() => {
        this.correspondantItem = Object.assign(
          {},
          this.corresspondantdefaultItem
        );
        this.correspondantIndex = -1;
      });
    },
    addPersonnel() {
      this.loading = true;
      if (this.correspondantIndex > -1) {
        Object.assign(
          this.corresspondantData[this.correspondantIndex],
          this.correspondantItem
        );
      } else {
        this.corresspondantData.push(this.correspondantItem);
      }
      this.correspondantClose();
      this.loading = false;
    },

    getFileFunction(item) {
      return new Promise((resolve, reject) => {
        this.getFile(item)
          .then((res) => {
            this.fileObject = this.File;
            resolve(true);
            console.log(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    async appelsModalFunction(item) {
      await this.getFileFunction(item._id);

      this.appelsModal = true;
    },
    // //call
    // async appelsModalFunction(item) {
    //   this.getFileFunction(item._id);

    //   this.appelsModal = true;
    // },
    //RDV
    appointmentDialogFunction(item) {
      this.getFileFunction(item._id);

      this.rdvModal = true;
    },
    //product
    productDialogFunction(item) {
      this.getFileFunction(item._id);

      this.productModal = true;
    },

    //product
    CotationDialogFunction(item) {
      this.getFileFunction(item._id);

      this.quotingModal = true;
    },
  },
};
</script>

<style scoped>
.btnDesign {
  color: #fff;
}

.space {
  margin-left: -100px;
  margin-right: -100px;
}

.pageTitle {
  font-size: 10px;
  font-weight: bold;
  color: #0482fb;
}

.green-bg {
  /* Set the display to `table-row` because Vuetify makes `flex` */
  display: table-row;
}

td {
  font-size: 12px !important;
  border-bottom: 1px solid #f4f7fe !important;
}

.green-bg:hover {
  /* `!important` is necessary here because Vuetify overrides this */
  background: #0482fb !important;
  color: white;
  height: 70px;
  animation: -45deg;
  cursor: pointer;
  box-shadow: inset 0 0 1em #0482fb, 0 0 2em #eeeeee;
}
</style>
